/*
 * @Descripttion:
 * @version:
 * @Author: tangshuo
 * @Date: 2022-10-17 14:54:58
 * @LastEditors: tangshuo
 * @LastEditTime: 2023-03-07 11:01:43
 */
import React from 'react';
import { notification, Icon } from '@firesoon/antd';
import { ArgsProps, NotificationApi } from '@firesoon/antd/lib/notification';
import './index.less';

interface props extends NotificationApi {
  loading?: (props: ArgsProps) => void;
}

const { success, error, info, warning, warn, open } = notification;

const Index: props = notification;

Index.success = function (props: ArgsProps) {
  return success({
    ...props,
    className: `${props?.className ?? ''} fs-notification`,
  });
};
Index.error = function (props: ArgsProps) {
  return error({
    ...props,
    className: `${props?.className ?? ''} fs-notification`,
  });
};
Index.info = function (props: ArgsProps) {
  return info({
    ...props,
    className: `${props?.className ?? ''} fs-notification`,
  });
};
Index.warning = function (props: ArgsProps) {
  return warning({
    ...props,
    className: `${props.className ?? ''} fs-notification`,
  });
};

Index.warning = function (props: ArgsProps) {
  return warning({
    ...props,
    className: `${props?.className ?? ''} fs-notification`,
  });
};
Index.warn = function (props: ArgsProps) {
  return warn({
    ...props,
    className: `${props?.className ?? ''} fs-notification`,
  });
};
Index.open = function (props: ArgsProps) {
  return open({
    ...props,
    className: `${props?.className ?? ''} fs-notification`,
  });
};
Index.loading = function (props) {
  return open({
    ...props,
    className: `${props?.className ?? ''} fs-notification`,
    icon: <Icon type="loading" />,
  });
};

export default Index;
